<template>
    <div
        v-if="isShow"
        :class="{
            'current-date-debugging': true,
            'open': isOpenBox
        }"
    >
        <div class="px-2 py-3">
            <label class="text-white mb-1 inline-block text-sm">Select date for preview</label>
            <DatePicker
                v-model="currentDate"
                type="date"
                value-type="format"
                format="YYYY-MM-DD"
                placeholder="Select start date"
                class="mr-2 mb-2 text-white"
            />
            <div class="bg-white text-center text-sm py-1 rounded cursor-pointer font-bold" @click="submit">Submit</div>
        </div>
        <div class="button-toggle cursor-pointer" @click="toggleShowBox" title="Toggle show select date box.">
            <i class="fa fa-angle-double-down text-white" v-if="!isOpenBox"></i>
            <i class="fa fa-angle-double-up text-white" v-else></i>
        </div>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'

export default {
    name: 'CurrentDateDebugging',

    components: {
        DatePicker,
    },

    data() {
        return {
            isShow: false,
            currentDate: null,
            isOpenBox: false,
            cookieName: 'current_date',
        }
    },

    mounted() {
        this.checkCookie()
    },

    methods: {
        toggleShowBox() {
            this.isOpenBox = !this.isOpenBox
        },

        async submit() {
            await this.setCookie(this.cookieName, this.currentDate, 1)

            window.location.reload()
        },

        setCookie(cname, cvalue, exdays) {
            let d = new Date()
            d.setTime(d.getTime() + (exdays*24*60*60*1000))
            let expires = 'expires='+ d.toUTCString()
            document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
        },

        getCookie(cname) {
            let name = cname + '='
            let decodedCookie = decodeURIComponent(document.cookie)
            let ca = decodedCookie.split(';')
            for(let i = 0; i <ca.length; i++) {
                let c = ca[i]
                while (c.charAt(0) == ' ') {
                    c = c.substring(1)
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length)
                }
            }
            return ''
        },

        checkCookie() {
            let date = new Date(this.getCookie(this.cookieName))
            let d = date.getDate().toString().padStart(2, '0')
            let m = (date.getMonth() + 1).toString().padStart(2, '0')
            let y = date.getFullYear()

            if (this.isValidDate(date)) {
                this.isShow = true
                this.currentDate = `${y}-${m}-${d}`
            }
        },

        isValidDate(d) {
            return d instanceof Date && !isNaN(d)
        }
    }
}
</script>

<style lang="scss">
@import '~vue2-datepicker/scss/index.scss';

.current-date-debugging {
    $current-date-box-height: 112px;

    position: fixed;
    top: -$current-date-box-height;
    left: 50%;
    transform: translateX(-50%);
    width: 300px;
    background-color: black;
    border-radius: 0 0 .3rem .3rem;
    height: $current-date-box-height;
    transition: .2s;

    &.open {
        top: 0;
    }

    .mx-datepicker {
        width: 100%;
        border: 1px solid #555;

        .mx-input-wrapper {
            height: 100%;

            .mx-input {
                height: 100%;
                font-size: 1rem;
                border: 0;
                background-color: transparent;
                color: white;
            }

            .mx-icon-clear>svg>path,
            .mx-icon-calendar>svg>path {
                fill: white;
            }
        }
    }

    .button-toggle {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: -1.75rem;
        height: 1.75rem;
        width: 2.75rem;
        background-color: black;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 0 0 .3rem .3rem;
    }
}
</style>